<template>
  <div class="org-reg customer-common">
    <div class="back">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="coutent">
      <div class="title" v-if="step !== 2">报名服务单位注册</div>
      <div class="block choice register-handle cus-style" v-if="step === 0">
        <div class="tips">请选择注册方式</div>
        <div class="ways">
          <van-button
            size="large"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            @click="step++"
            >填写赛事组织单位注册码</van-button
          >
          <van-button
            size="large"
            @click="pullScan"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            >扫描赛事组织单位二维码</van-button
          >
        </div>
      </div>
      <div class="block reg-code register-handle cus-style" v-if="step === 1">
        <div class="tips">使用赛事组织单位码注册</div>
        <div class="reg-code-val">
          <input
            type="text"
            v-model="regCode"
            placeholder="请输入赛事组织单位注册码"
          />
        </div>
        <div class="next-btn">
          <van-button
            size="large"
            @click="channelCodeConfirm"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            >下一步</van-button
          >
        </div>
      </div>
      <div class="block reg-detail" v-if="step === 2">
        <div class="scan-bind-head" v-if="scanBind">
          <div class="icon">
            <img src="../../assets/images/register/bind-ico.png" alt="" />
          </div>
          <div class="name">正在绑定{{ chanName }}</div>
          <p>完善信息即可完成绑定</p>
        </div>
        <!-- <div class="detail-title">报名服务单位信息</div> -->
        <div class="detail-field">
          <van-field
            v-model="formData.name"
            input-align="right"
            required
            name="name"
            label-width="8.2em"
            label="报名服务单位名称"
            placeholder="请输入报名服务单位名称"
            error-message-align="right"
            :error-message="validate.fieldMsg.name"
          />
          <van-field
            readonly
            input-align="right"
            clickable
            name="city"
            required
            v-model="formData.city"
            label="报名服务单位地址"
            label-width="8.2em"
            placeholder="请选择报名服务单位地址"
            error-message-align="right"
            :error-message="validate.fieldMsg.city"
            @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
              :area-list="areaList"
              @confirm="onConfirm"
              @cancel="showArea = false"
            />
          </van-popup>

          <van-field
            name="address"
            required
            v-model="formData.address"
            placeholder="详细联系地址"
            error-message-align="right"
            :error-message="validate.fieldMsg.address"
            :style="{ marginBottom: '20px' }"
          />

          <van-field
            input-align="right"
            required
            v-model="formData.license"
            name="license"
            label="执照编码"
            placeholder="请输入主体执照编码"
            error-message-align="right"
            :error-message="validate.fieldMsg.license"
          />

          <van-field label-class="affixs-label" required>
            <template #label>
              <span class="custom-title">资质证件</span>
              <span class="custom-tit">(确保清清晰完整，最多3张)</span>
            </template>
          </van-field>
          <!-- 由于uploader 的小bug  此处 设置最大数量为 4 ，但当文件数量大于等于3时隐藏 上传点击按钮 -->
          <div
            :class="[
              'aptitudes-list',
              fileList.length >= 3 ? 'hidden-upload' : ''
            ]"
          >
            <van-uploader
              v-model="fileList"
              :max-count="4"
              :before-read="aptitudesBeforeRead"
            />
          </div>

          <van-field label-width="9.2em">
            <template #label>
              <span class="custom-title">报名服务单位LOGO</span>
            </template>
          </van-field>

          <div class="logo-list">
            <van-uploader
              v-model="logo"
              :max-count="1"
              :before-read="logoBeforeRead"
            />
          </div>

          <van-field
            rows="4"
            v-model="formData.intro"
            autosize
            label="报名服务单位简介"
            required
            name="intro"
            type="textarea"
            label-width="8.2em"
            placeholder="请输入报名服务单位简介"
            maxlength="300"
            show-word-limit
            :style="{ marginBottom: '20px' }"
            error-message-align="right"
            :error-message="validate.fieldMsg.intro"
          />

          <van-field
            v-model="formData.responsible"
            input-align="right"
            required
            name="responsible"
            label="报名服务单位联系人"
            label-width="9.2em"
            placeholder="请输入报名服务单位联系人姓名"
            error-message-align="right"
            :error-message="validate.fieldMsg.responsible"
          />

          <van-field
            input-align="right"
            required
            name="mail"
            v-model="formData.mail"
            label="联系邮箱"
            placeholder="请输入联系邮箱"
            error-message-align="right"
            :error-message="validate.reg_verify_err_msg.mail"
            @change="validate.mail('mail')"
          />

          <van-field
            input-align="right"
            required
            name="telephone"
            v-model="formData.telephone"
            label="联系电话"
            maxlength="11"
            placeholder="请输入联系电话"
            error-message-align="right"
            :error-message="validate.reg_verify_err_msg.telephone"
            @change="validate.tel('telephone')"
          />

          <van-field
            input-align="right"
            required
            v-model="formData.wechatID"
            name="wechatID"
            label="微信号"
            placeholder="请输入微信号"
            error-message-align="right"
            :error-message="validate.fieldMsg.wechatID"
            :style="{ marginBottom: '20px' }"
          />
        </div>
        <!-- <div class="detail-title">账号信息</div> -->
        <div class="input">
          <van-field
            v-model="formData.phone"
            center
            clearable
            required
            name="phone"
            label="手机号码"
            maxlength="11"
            input-align="right"
            placeholder="用于登录报名服务单位端"
            :error="validate.reg_verify_err.phone"
            @change="validate.tel('phone')"
          >
          </van-field>
          <van-field
            v-model="formData.code"
            center
            clearable
            name="code"
            required
            label="验证码"
            input-align="right"
            placeholder="请输入验证码"
            type="digit"
            max-length="6"
            :error="validate.reg_verify_err.code"
            @change="validate.code('code')"
          >
            <template #button>
              <span
                size="small"
                round
                @click="sendCode"
                style="color: #6cdd8f"
                >{{ sendClip ? "发送验证码" : `${second}s` }}</span
              >
            </template>
          </van-field>
          <van-field
            v-model="formData.pwd"
            center
            clearable
            required
            label="登录密码"
            input-align="right"
            placeholder="用于报名服务单位端登录"
            :error="validate.reg_verify_err.pwd"
            @change="validate.pwd('pwd')"
          >
          </van-field>
          <van-field
            v-model="formData.rpwd"
            center
            clearable
            required
            label="重复密码"
            input-align="right"
            placeholder="请再次输入密码"
            :error="validate.reg_verify_err.rpwd"
            @change="validate.rpwd('pwd', 'rpwd')"
          >
          </van-field>
        </div>
        <div class="end-btn">
          <van-button
            size="large"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            @click="submitInfo"
            >提交认证</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import { getRegiserTelCode, uploadImg } from "@/utils/api/user";
import {
  registerInstitution,
  getChannelInfoByRegisterCode
} from "@/utils/api/org";
import { checkUploadFile } from "@/utils/tool";
import { validate } from "@/utils/mixin/validate";
import { signature } from "@/utils/mixin/wx-js-sdk-signature";
export default {
  mixins: [validate, signature],
  data() {
    return {
      // 注册步骤
      step: 0,
      // 渠道名称
      chanName: "",
      // 渠道注册码
      regCode: "",
      // 渠道id
      regId: "",
      // 是否扫码进入
      scanBind: false,
      // 需要提交的表单内容
      formData: {
        name: "",
        city: "",
        address: "",
        license: "",
        aptitudes: "",
        logo: "",
        responsible: "",
        intro: "",
        phone: "",
        code: "",
        pwd: "",
        rpwd: "",
        mail: "",
        telephone: "",
        wechatID: ""
      },
      // 展示区域
      showArea: false,
      // 区域树
      areaList,
      // 资质文件
      fileList: [],
      //
      logo: [],
      // 是否能发送短信
      sendClip: true,
      // 定时器
      itv: null,
      // 定时器秒
      second: 60,
      // 页面需要注册的权限
      jsApiList: ["scanQRCode"]
    };
  },
  methods: {
    // 拉起扫码功能
    pullScan() {
      /* eslint-disable */
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: (res) => {
            this.getChannelId(res.resultStr);
          },
          fail: (err) => {
            const followed = err.errMsg.indexOf(
              "the permission value is offline verifying"
            );
            if (followed > 0) {
              this.$notify({
                type: "danger",
                message: "请检查是否关注该公众号"
              });
              this.$root.$toast.fail({
                message: "获取页面权限失败，请刷新页面后重试！",
                duration: 2000,
                onClose: () => {
                  this.refreshJSToken();
                }
              });
            } else {
              this.$root.$toast.fail({
                message: JSON.stringify(err),
                duration: 2000,
                onClose: () => {
                  this.refreshJSToken();
                }
              });
            }
          }
        });
      });
      /* eslint-disable */
    },
    // 发送验证码
    sendCode() {
      if (!this.sendClip) {
        return;
      }
      const res = this.validate.tel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      getRegiserTelCode(this.formData.phone).then((res) => {
        if (res.success) {
          this.sendClip = false;
          this.codeInterval();
        }
      });
    },
    // 倒计时
    codeInterval() {
      this.itv = setInterval(() => {
        this.second--;
        if (!this.second) {
          this.second = 60;
          this.sendClip = true;
          window.clearInterval(this.itv);
        }
      }, 1000);
    },
    // 地址确认
    onConfirm(values) {
      this.formData.city = `${values[0].name} ${values[1].name} ${values[2].name}`;
      this.showArea = false;
    },
    // 获得渠道id
    getChannelId(code = null) {
      getChannelInfoByRegisterCode({
        registerCode: code ? code : this.regCode
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            this.regId = res.data.id;
            this.chanName = res.data.name;
            this.scanBind = true;
            this.step = 2;
          } else {
            this.$root.$toast.fail("无赛事组织单位信息");
          }
        }
      });
    },
    // 资质上传
    aptitudesBeforeRead(file, { index }) {
      const pass = checkUploadFile({ file, size: 10 }, (err) => {
        this.$root.$toast.fail(err);
      });
      if (!pass) {
        return false;
      }
      this.fileList[index] = {
        url: "",
        status: "uploading",
        message: "上传中..."
      };
      this.$forceUpdate();
      let upimgobj = new FormData();
      upimgobj.append("file", file);
      uploadImg(upimgobj).then(({ success, data: url }) => {
        if (success) {
          this.fileList[index] = {
            url,
            status: "done"
          };
          this.$forceUpdate();
          return success;
        } else {
          this.fileList[index] = {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed"
          };
          this.$forceUpdate();
          return success;
        }
      });
    },
    // logo 上传
    logoBeforeRead(file) {
      const pass = checkUploadFile({ file, size: 5 }, (err) => {
        this.$root.$toast.fail(err);
      });
      if (!pass) {
        return false;
      }
      this.logo = [
        {
          url: "",
          status: "uploading",
          message: "上传中..."
        }
      ];
      this.$forceUpdate();
      let upimgobj = new FormData();
      upimgobj.append("file", file);
      uploadImg(upimgobj).then(({ success, data: url }) => {
        if (success) {
          this.logo = [
            {
              url,
              status: "done"
            }
          ];
          this.$forceUpdate();
          return success;
        } else {
          this.logo = [
            {
              url: "",
              message: "上传失败，请重新上传",
              status: "failed"
            }
          ];
          this.$forceUpdate();
          return success;
        }
      });
    },
    channelCodeConfirm() {
      if (!this.regCode) {
        this.$root.$toast.fail("请填写注册码");
        return;
      }
      this.getChannelId();
    },
    async submitInfo() {
      if (this.fileList.length === 0) {
        this.$root.$toast.fail("请上传资质证件！");
        return;
      } else {
        this.formData.aptitudes = this.fileList
          .map((e) => {
            return e.url;
          })
          .join(",");
      }

      if (this.logo.length === 0) {
        this.$root.$toast.fail("请上传Logo图片");
        return;
      } else {
        this.formData.logo = this.logo[0].url;
      }

      // 验证数据;
      const dataValidate = () => {
        return new Promise((res) => {
          const lastKey = "wechatID";
          for (let key in this.formData) {
            let pass = this.validate.isNull(key);
            if (!pass) res(false);
            if (key === lastKey) res(true);
            this.$forceUpdate();
          }
        });
      };
      const result = await dataValidate();
      if (!result) {
        this.$root.$toast.fail("数据填写不完整！请检查后重试");
        this.validate.errMsgPopup();
        this.validate.errMsgEmpty();
        return;
      } else {
        const {
          name,
          city,
          address,
          license,
          aptitudes,
          logo,
          responsible,
          intro,
          phone,
          code,
          pwd,
          mail,
          telephone,
          wechatID
        } = this.formData;
        const p = {
          channelId: this.regId,
          code: phone,
          contactAddress: address,
          contactArea: city.split(" ")[2],
          contactCity: city.split(" ")[1],
          contactProvince: city.split(" ")[0],
          contactEmail: mail,
          contactsTel: telephone,
          credentialsImg: aptitudes,
          logo,
          license,
          name,
          password: pwd,
          personCharge: responsible,
          synopsis: intro,
          telCode: code,
          wxAccounts: wechatID
        };
        registerInstitution(p).then((res) => {
          if (res.success) {
            this.$root.$toast.success({
              duration: 2000,
              message: "提交成功",
              onClose: () => {
                this.$router.push("/login");
              }
            });
          }
        });
      }
    },
    // 测试用数据
    sb2() {
      const p = {
        channelId: 7,
        code: "13637717756",
        contactAddress: "地址",
        contactArea: "九龙坡区",
        contactCity: "重庆市",
        contactProvince: "重庆市",
        contactEmail: "123@qq.com",
        contactsTel: "13637717756",
        credentialsImg:
          "https://motherlandh5.oss-cn-beijing.aliyuncs.com/2022/02/09/15/34/halo.jpg",
        logo: "https://motherlandh5.oss-cn-beijing.aliyuncs.com/2022/02/09/15/34/halo.jpg",
        license: "bm1",
        name: "报名服务单位名称",
        password: "123456",
        personCharge: "负责人",
        synopsis: "报名服务单位简介",
        telCode: "154264",
        wxAccounts: "13637717756"
      };
      registerInstitution(p).then((res) => {
        if (res.success) {
          this.$root.$toast.success({
            duration: 2000,
            message: "提交成功",
            onClose: () => {
              this.$router.push("/login");
            }
          });
        }
      });
    }
  },
  mounted() {
    this.validate.setFormDataKey("formData");
  }
};
</script>

<style lang="scss" scoped>
.org-reg {
  height: 100vh;
  width: 100vw;
  background-image: url("../../assets/images/register/back-0.png");
  background-position: 0 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: scroll;
  .back {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 0;
    height: 100%;
    div {
      position: absolute;
      background-position: 0 0;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      &:nth-child(1) {
        top: -1px;
        left: 0;
        width: 144px;
        height: 135px;
        background-image: url("../../assets/images/register/back-1.png");
      }
      &:nth-child(2) {
        top: 0;
        right: 0;
        width: 50px;
        height: 69px;
        background-image: url("../../assets/images/register/back-2.png");
      }
      &:nth-child(3) {
        top: 48px;
        left: 183px;
        width: 73px;
        height: 73px;
        background-image: url("../../assets/images/register/back-3.png");
      }
    }
  }
  .coutent {
    position: absolute;
    min-width: 100vw;
    min-height: 100vh;
    z-index: 2;
  }
  .title {
    width: 100%;
    z-index: 1;
    font-size: 28px;
    color: #666;
    margin-top: 60px;
    font-weight: 700;
  }
  .block {
    .tips {
      color: #333;
      font-size: 14px;
    }
    .next-btn {
      width: 335px;
      margin: 0 auto;
      margin-top: 94px;
    }
    &.choice {
      margin-top: 90px;
      .ways {
        margin: 0 auto;
        margin-top: 32px;
        width: 295px;
        .van-button {
          border-radius: 16px;
          width: 254px;
          height: 32px;
        }
      }
    }
    &.reg-code {
      margin-top: 90px;
      .reg-code-val {
        width: 254px;
        height: 32px;
        border-radius: 16px;
        background-color: #eee;
        display: flex;
        align-items: center;
        padding: 0 10px;
        margin: 0 auto;
        margin-top: 64px;
        input {
          background-color: unset;
          border: none;
          font-size: 13px;
          width: 100%;
          height: 100%;
        }
      }
    }
    &.reg-info {
      .input {
        width: 335px;
        overflow: hidden;
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 70px;
        margin-bottom: 20px;
        .pwd-ico {
          background: url("../../assets/images/login/password.png") no-repeat;
        }
        .rpwd-ico {
          background: url("../../assets/images/login/password.png") no-repeat;
        }
        .phone-ico {
          background: url("../../assets/images/login/phone.png") no-repeat;
        }
        .mail-ico {
          background: url("../../assets/images/login/mail.png") no-repeat;
        }
        .inp-ico {
          width: 55px;
          height: 55px;
          background-size: 20px 20px;
          background-position: center center;
        }
      }
      .next-btn {
        margin-top: 28px;
        .van-button {
          border-radius: 16px;
          width: 254px;
          height: 32px;
        }
      }
    }
    &.reg-detail {
      // margin-top: 60px;
      .scan-bind-head {
        display: flex;
        align-items: center;
        flex-direction: column;
        background: #fff;
        .icon {
          height: 48px;
          width: 48px;
          border-radius: 4px;
          background: #6cdd8f;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 16px;
          img {
            height: 40px;
            width: 40px;
          }
        }
        .name {
          font-size: 16px;
          line-height: 22px;
          margin-top: 8px;
          color: #666;
        }
        p {
          margin-top: 4px;
          font-size: 12px;
          color: #999;
          line-height: 17px;
        }
      }
      width: 100vw;
      background: #f9f9f9;
      // padding: 0 20px;
      overflow: hidden;
      .detail-title {
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          height: 18px;
          width: 5px;
          background-color: #16d77a;
          margin-right: 10px;
          border-radius: 2px;
        }
        font-size: 14px;
        color: #666;
        height: 50px;
        line-height: 50px;
      }
      .van-cell {
        text-align: left;
      }
      .custom-title {
        color: #646566;
        &::before {
          margin-left: -8px;
          content: "*";
          color: #ee0a24;
          margin-right: 2px;
        }
      }
      .custom-tit {
        font-size: 12px;
        color: #ccc;
      }
      .aptitudes-list {
        text-align: left;
      }
      .detail-field {
      }
      .end-btn {
        margin-top: 40px;
        margin-bottom: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        .van-button {
          border-radius: 16px;
          width: 254px;
          height: 32px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
.org-reg {
  .van-button:not(.van-button--round) {
    border-radius: 16px;
    margin-bottom: 20px;
    .van-button__text {
      font-size: 14px;
    }
  }

  .input {
    .van-cell {
      &::after {
        border: none;
      }
    }
    .van-field__button {
      padding-right: 12px;
    }
  }

  .detail-field {
    .van-cell {
      &::after {
        border: none;
      }
    }
    .affixs-label {
      width: unset;
      & + .van-field__value {
        display: none;
      }
    }
  }
  .aptitudes-list,
  .logo-list {
    &.hidden-upload {
      .van-uploader {
        .van-uploader__upload {
          display: none;
        }
      }
    }
    text-align: left;
    background-color: #fff;
    .van-uploader {
      @include from-upload-style;
    }
  }
}
</style>
